import React, { Component } from 'react';
import List from './List';
import { deleteChild } from '../actions';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import {
	PARENT_FETCH_REQUEST, PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE,
	CHILD_DELETE_REQUEST, CHILD_DELETE_SUCCESS, CHILD_DELETE_FAILURE
} from '../actions';

class Children extends Component {
	constructor(props) {
		super(props);
		this.handleSelect = this.handleSelect.bind(this);
		this.handleSelectNew = this.handleSelectNew.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	handleSelect(child) {
		this.props.history.push(`/children/${child.id}`);
	}

	handleSelectNew() {
		this.props.history.push('/booking/child?add=true&reset=true');
	}

	handleDelete(child) {
		this.props.deleteChild(child.id);
	}

	render() {
		return (
			<div>
				<ReduxBlockUi block={[PARENT_FETCH_REQUEST, CHILD_DELETE_REQUEST]} unblock={[PARENT_FETCH_SUCCESS, PARENT_FETCH_FAILURE, CHILD_DELETE_SUCCESS, CHILD_DELETE_FAILURE]}>
					<List data={this.props.children} onSelect={this.handleSelect} onSelectNew={this.handleSelectNew} showOptions
						canDelete={this.props.canDeleteChild} onDelete={this.handleDelete}
						enableCollectMedicalInformation={this.props.enableCollectMedicalInformation} />
				</ReduxBlockUi>
			</div>);
	}
}

const mapStateToProps = state => {
	const { parent: { children }, auth: { currentUser }, configuration: { franchisor } } = state;

	return {
		children,
		canDeleteChild: currentUser.userImpersonation,
		enableCollectMedicalInformation: franchisor.enableCollectMedicalInformation
	};
};

export default connect(mapStateToProps, {
	deleteChild
})(withNamespaces()(Children));